import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { PAGE_SIZE_OPTIONS } from './_filter-options';

/**
 * Select de tamanho de página compartilhado pelas filter bars admin.
 *
 * Aceita `options` para customizar (Observability usa [50,100,200,500] e
 * label "Limite", por exemplo).
 */
interface PageSizeSelectProps {
  value: number;
  onChange: (value: number) => void;
  options?: readonly number[];
  /** Largura do trigger no breakpoint sm. Default: `sm:w-[120px]`. */
  width?: string;
  /** Label do campo. Default: "Por página". */
  label?: string;
  /** Sufixo na opção: "{n} {itemLabel}". Default: "registros". */
  itemLabel?: string;
}

export function PageSizeSelect({
  value,
  onChange,
  options = PAGE_SIZE_OPTIONS,
  width = 'sm:w-[120px]',
  label = 'Por página',
  itemLabel = 'registros',
}: PageSizeSelectProps) {
  return (
    <div className="space-y-1">
      <Label className="text-xs font-medium">{label}</Label>
      <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
        <SelectTrigger className={`w-full ${width}`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((n) => (
            <SelectItem key={n} value={String(n)}>
              {n} {itemLabel}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
